const RadioButton = (props) => {
    return (
        <label className="container" htmlFor={props.htmlFor}>{props.title}
            <input id={props.id} name={props.name} type="checkbox" value={props.value} disabled={props.disabled} onClick={props.onClick} onChange={props.onChange} checked={props.checked}/>
            <span className={`checkmark ${props.className}`} title="Velg"></span>
        </label>
    );
};

export default RadioButton;